import React, { useState } from "react"
import Typography from "@mui/material/Typography"
import Box from "@mui/material/Box"
import Grid from "@mui/material/Grid2"
import PropertiesForm from "./PropertiesForm"
import PropertiesTable from "./PropertiesTable"

/**
 * Properties page.
 *
 * Intentionally thin: it only owns the `selectedPropertyId` piece of UI state
 * (which row is currently selected / being edited) and distributes it to its
 * two children.  All data-fetching and mutation logic lives in PropertiesForm
 * and PropertiesTable respectively.
 *
 * @param {import('@supabase/supabase-js').SupabaseClient} supabase
 */
export default function Properties({ supabase }) {
    const [selectedPropertyId, setSelectedPropertyId] = useState(null)

    return (
        <Box sx={{ width: "100%" }}>
            <Grid container spacing={4}>
                <Grid size={{ xs: 12, lg: 4 }}>
                    <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
                        {selectedPropertyId ? "Modifier un bien" : "Ajouter un bien"}
                    </Typography>
                    <PropertiesForm
                        supabase={supabase}
                        selectedPropertyId={selectedPropertyId}
                        onSaved={() => setSelectedPropertyId(null)}
                    />
                </Grid>
                <Grid size={{ xs: 12, lg: 8 }}>
                    <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
                        Annuaire des biens
                    </Typography>
                    <PropertiesTable
                        supabase={supabase}
                        selectedPropertyId={selectedPropertyId}
                        setSelectedPropertyId={setSelectedPropertyId}
                    />
                </Grid>
            </Grid>
        </Box>
    )
}